var _defs, _rect, _ellipse, _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPlaceholderSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradientSquare",
    x1: 22,
    y1: 18,
    x2: 218,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A4F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinGradientSquare",
    x1: 120,
    y1: 54,
    x2: 120,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "haloGradientSquare",
    x1: 48,
    y1: 188,
    x2: 192,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 16,
    fill: "url(#bgGradientSquare)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 188,
    rx: 72,
    ry: 16,
    fill: "url(#haloGradientSquare)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 54C90.5 54 66.5 77.9 66.5 107.5C66.5 123.7 74.4 138.7 87.4 149.6L118.8 177.1C119.5 177.7 120.5 177.7 121.2 177.1L152.6 149.6C165.6 138.7 173.5 123.7 173.5 107.5C173.5 77.9 149.5 54 120 54Z",
    fill: "url(#pinGradientSquare)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 107,
    r: 22,
    fill: "#2A4F8E",
    fillOpacity: 0.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 107,
    r: 10,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4 149.6L118.8 177.1C119.5 177.7 120.5 177.7 121.2 177.1L152.6 149.6C156.4 146.4 159.8 142.8 162.8 138.9C151.8 144.4 136.6 147.8 120 147.8C103.4 147.8 88.2 144.4 77.2 138.9C80.2 142.8 83.6 146.4 87.4 149.6Z",
    fill: "#D4DEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlaceholderSquare);
export default __webpack_public_path__ + "static/media/LocationPlaceholderSquare.6212e18c1a33f24226cdd4dea35716f9.svg";
export { ForwardRef as ReactComponent };